import React from "react";
/**
 * Render the label in the month caption.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function CaptionLabel(props) {
    return React.createElement("span", { ...props });
}
//# sourceMappingURL=CaptionLabel.js.map